// extracted by mini-css-extract-plugin
export var dark = "fullColumnTextCta-module--dark--c22b7";
export var fullColumnTextCta = "fullColumnTextCta-module--fullColumnTextCta--b6815";
export var light = "fullColumnTextCta-module--light--07504";
export var styledButtons = "fullColumnTextCta-module--styledButtons--27096";
export var styledHeadline = "fullColumnTextCta-module--styledHeadline--4beed";